import React from 'react'
import Game from './Game'
import { render, getConfig, CONTENT_TYPE, shuffle, TYPE_QUESTIONS } from '@educaplay/core'
import { assetsUrl, GameProvider } from '@educaplay/core'
import { initialize } from '@educaplay/store'
import { QUESTION_TYPE } from './utils/constants'
import { calculateCasePoints, checkTypeAnswer } from './utils/functions'
import { isUnansweredAnswer } from '@educaplay/store/utils/functions'
import { initErrorMonitoring } from '@educaplay/core/utils'

initErrorMonitoring("https://1d0102a3d2cf1635bdfc77218ca8b241@o4509038211104768.ingest.de.sentry.io/4509045267234896");

const TEST_SOUNDS = {
  'test-submit': assetsUrl('TEST/activar.mp3'),
  'test-showButton': assetsUrl('TEST/bienactivo.mp3'),
  'test-deselect': assetsUrl('TEST/carga.mp3'),
  'test-load': assetsUrl('TEST/colocar.mp3'),
  'test-delete':assetsUrl('TEST/escalar.mp3'),
  'test-write': assetsUrl('TEST/escribir.mp3'),
  'test-move': assetsUrl('TEST/mover.mp3'),
}

const gameImage = assetsUrl("TEST/logoActivity.png");
const container = document.getElementById('root');

async function init() {
  const { data, texts, settings, user, title, description, author, id, url } = await getConfig().catch((err) =>
    console.error('Error al obtener la configuración: ', err)
  )

  const isCaseSensitive = data.SENSIBLE_MAYUSCULAS_ACENTOS === 'si';
  const isExamMode = data.EXAMEN === "si" ? true : false;


  const { resources } = settings
  const filteredQuestions = data.PREGUNTAS
    .map((question, index) => ({ ...question, id: index }))
    .filter((question) => question.ENUNCIADO !== "" || question.MULTIMEDIA )
    .map(question => { 
      return {
        ...question,
        RESPUESTAS: question.RESPUESTAS.filter(response => response.RESPUESTA !== "" || response.MULTIMEDIA )
      }
    })
    .filter((question) => question.ESCRITA !=="si" || (question.ESCRITA === "si"  && question.RESPUESTAS.some(response => response.RESPUESTA !== "")))//Tener 1 respuesta con texto si está activado ESCRITA
    .filter((question) => question.ESCRITA ==="si" || (question.ESCRITA !== "si" && question.RESPUESTAS.length >= 2 && question.RESPUESTAS.some(response => response.RESPUESTA_CORRECTA === "si")))
    
  const questionTimeNumber = Number(data.TIEMPO)
  const questionTime = Number.isNaN(questionTimeNumber) ? 0 : questionTimeNumber

  const isPenalized = isExamMode && data.PENALIZACION_ACTIVA === 'si';
  const penalty = isPenalized ? -data.PENALIZACION : 0;

  const visibleQuestionsActived = data.NUMERO_PREGUNTAS_VISIBLES_ACTIVO === "si";
  const numShowQuestion = (visibleQuestionsActived && data.NUMERO_PREGUNTAS_VISIBLES <= filteredQuestions.length )  ? data.NUMERO_PREGUNTAS_VISIBLES : filteredQuestions.length;

  const questions = filteredQuestions.map(question => {
    const questionType = (question.ESCRITA === "si") ? QUESTION_TYPE.TextQuestion : (question.MULTIPLE === "si") ? QUESTION_TYPE.MultiQuestion : QUESTION_TYPE.SingleQuestion;
    const correctAnswers = question.RESPUESTAS.map((answer, index) => ({...answer, id: index })).filter(answer => questionType === QUESTION_TYPE.TextQuestion ? true : answer.RESPUESTA_CORRECTA === "si").map(answer => answer.id.toString());

    const points = 100 / numShowQuestion; //TODO: Revisar que funciona bien cuando este el editor

    const answers = shuffle(question.RESPUESTAS.map((answer, index) => {
      return {
        answer: answer.RESPUESTA,
        source: answer.MULTIMEDIA ? `${resources}${answer.MULTIMEDIA}` : null,
        type: answer.MULTIMEDIA_TIPO ?? null,
        id: index.toString(),
      }
    }))

    const checkAnswer = (objAnswer) => {
      if(isUnansweredAnswer(objAnswer.answer ?? null,{examMode: isExamMode})) return false;
      if(!objAnswer) return false;
      const textCorrectAnswers = correctAnswers.map(answerID => answers.find(answer => answer.id === answerID).answer);
      if(objAnswer.type === TYPE_QUESTIONS.Text) return checkTypeAnswer({ sortedAnswered: objAnswer.answer, correctAnswers: textCorrectAnswers, questionType: objAnswer.type, isCaseSensitive })
      
      const answer =  Array.isArray(objAnswer.answer) 
        ? objAnswer.answer.map(answerID => answers.find(answer => answer.id === answerID).id).sort((a,b) => {return a - b })
        : answers.find(answer => answer.id === objAnswer.answer).id;

      return checkTypeAnswer({ sortedAnswered:answer, correctAnswers, questionType: objAnswer.type, isCaseSensitive });
    }

    const calculatePoints = (answer) => {
      if(!answer) return 0;
      const sortedAnswered = Array.isArray(answer.answer) ? answer.answer?.sort((a,b) => {return a - b }) : answer.answer;
      const textCorrectAnswers = correctAnswers.map(answerID => answers.find(answer => answer.id === answerID).answer);
      const checkAnswers = questionType === QUESTION_TYPE.TextQuestion ?  textCorrectAnswers : correctAnswers;
      return calculateCasePoints({ sortedAnswered, correctAnswers: checkAnswers, question, points, questionType, isCaseSensitive, penalty });
    }
    return {
      text: question.ENUNCIADO,
      media: question.MULTIMEDIA ? {
        type: question.MULTIMEDIA_TIPO,
        src: question.MULTIMEDIA_TIPO === CONTENT_TYPE.YOUTUBE ? question.MULTIMEDIA : `${resources}${question.MULTIMEDIA}`,
      } : null,
      questionType: questionType,
      examMode: isExamMode,
      answers,
      feedback: (question.EXPLICACION_ACTIVA === "si") ? question.EXPLICACION ?? null : null,
      bank: (question.ENUNCIADO || question.MULTIMEDIA) ? {
        text: question.ENUNCIADO,
        source: question.MULTIMEDIA_TIPO === CONTENT_TYPE.YOUTUBE ? question.MULTIMEDIA : `${resources}${question.MULTIMEDIA}`,
        type: question.MULTIMEDIA_TIPO ?? CONTENT_TYPE.TEXT
      } : null,
      checkAnswer,
      correctAnswers,
      calculatePoints,
      answer: null,
      points,
      time: questionTime,
      id: question.id,
    }
  });

  initialize({
    lives: data.NUMERO_INTENTOS,
    liveActived: (data.NUMERO_INTENTOS_INFINITOS !== "si" && !isExamMode),
    hasCountDown: data.MAXIMO === "si",
    globalCountdown: isExamMode ? (questionTime * numShowQuestion) : null,
    randomized: data.ALEATORIO === "si" || visibleQuestionsActived,
    showSolutions: data.OCULTAR_RESPUESTAS !== '1',
    showRestart: data.OCULTAR_REINICIAR !== '1',
    showSocialMedia: data.OCULTAR_REDES !== '1',
    showUserAnswer: true,
    hasSkip: true,
    semiCorrect: true,
    hasProgressBar: {view: true, onlyCorrect: false},
    numberOfQuestions: numShowQuestion,
    finalText: data.TEXTO_FINAL,
    hasBank: true,
    examMode: isExamMode,
    showFeedbackGame: !(data.EXPLICACIONES_FINAL === 'si') && !isExamMode,
    questions,
    settings,
    title,
    description,
    author,
    id,
    url,
    user,
    customizations: {
      customLogo: data.LOGO,
      customBarLogo: data.FRANJA,
      backgroundImage: {src: data.BACKGROUND, showGame: true},
      colors: {
        primary: data.COLOR_FONDO,
        text: data.COLOR_FUENTE,
        action: data.COLOR_BOTONES,
        textAction: data.COLOR_FUENTE_B,
      }
    }
  });

  render(container, (
      <GameProvider
        gameImage={gameImage}
        texts={texts}
        Game={Game}
        sounds={TEST_SOUNDS}
        hasCustomLayout
        mappers={{
          report: (question) => {
            const isCorrect = question.checkAnswer(question.answer)
            
            const formattedAnswer = Array.isArray(question.answer.answer)
              ? question.answer.answer.map(Number)
              : [Number(question.answer.answer)]
            
            return {
              s: isCorrect,
              i: question.id,
              a: question.questionType === QUESTION_TYPE.TextQuestion ? question.answer.answer : formattedAnswer
            }
          }
        }}
        renders={{
          infoLeft: (currentIndex, questions) => {
            return `${texts.common.game.question}: ${Math.min(currentIndex + 1, questions.length)} / ${questions.length}`
          },

          infoRight: (currentIndex ,questions) =>{
            if (isExamMode) {
              const answeredQuestions = questions.filter(question => (
                !isUnansweredAnswer(question.answer,{examMode: isExamMode}))).length;
              return `${answeredQuestions}/${questions.length} `
            }
          }
        }}
      />
  ))
}

init();